@let r = resumen;
<div class="hom">
  <!-- Encabezado: el veredicto del harness es una recomendación, no el dictamen -->
  <section class="hom-card hom-encabezado">
    <div class="hom-encabezado__fila">
      <div class="hom-encabezado__titulos">
        <p class="hom-kicker">Resultado resumido</p>
        <h2 class="hom-h2">
          {{ r.modelo }}
          @if (r.vigente) {
            <span class="table-page__status-badge is-active hom-veredicto">Vigente</span>
          }
        </h2>
      </div>
      <span class="table-page__status-badge hom-veredicto" [class]="'table-page__status-badge hom-veredicto ' + veredictoClase(r.veredicto)">
        {{ veredictoTexto(r.veredicto) }} {{ coletilla(r.estatus) }}
      </span>
    </div>
    <p class="hom-encabezado__linea">
      {{ r.nombreConfiguracion || "—" }} · <code class="hom-mono">{{ r.identificador }}</code> · corrida <code class="hom-mono">{{ r.runId }}</code>
      @if (r.repeticiones) { · {{ r.repeticiones }} rep. }
      @if (r.aplicadaDesde) { · aplicada el {{ r.aplicadaDesde }} }
    </p>
    <p class="hom-encabezado__linea hom-encabezado__linea--suave">
      @if (r.esBaseline) {
        Es el baseline de su vara: las siguientes homologaciones se comparan contra él.
      } @else if (r.baselineModelo) {
        Comparado contra {{ r.baselineModelo }} · corrida <code class="hom-mono">{{ r.baselineRunId }}</code>
      } @else {
        Sin baseline: se ve sin deltas.
      }
    </p>
    @if (r.dictamen) {
      <p class="hom-encabezado__dictamen"><strong>Dictamen:</strong> {{ dictamenTexto(r.dictamen) }} · firmado el {{ r.fechaFirma || "—" }}</p>
    }
    @if (r.baselineReemplazado) {
      <p class="hom-aviso" role="status">Su baseline se recalificó después: los deltas son contra una calificación que ya no vale. Hay que recalificarlo; por eso no entra a la comparativa.</p>
    }
  </section>

  <!-- Ficha del catálogo: informa, no califica (spec 5.8). Los precios se comparan contra los de ESTA evaluación -->
  @if (ficha) {
    <app-ficha-catalogo [ficha]="ficha" [preciosEval]="preciosEval"></app-ficha-catalogo>
  }

  <!-- KPIs -->
  <section class="hom-kpis hom-kpis--seis" aria-label="Indicadores del resultado">
    <article class="hom-kpi">
      <span class="hom-kpi__etiqueta">Capacidad</span>
      <strong class="hom-kpi__valor">@if (num(r.capacidad) !== null) { {{ r.capacidad | number: "1.1-1" }} } @else { — }</strong>
      @if (!r.esBaseline && num(r.deltaCapacidad) !== null) {
        <span class="hom-kpi__delta" [attr.data-signo]="signo(r.deltaCapacidad)">{{ conSigno(r.deltaCapacidad) }} pts vs baseline</span>
      }
    </article>
    <article class="hom-kpi">
      <span class="hom-kpi__etiqueta">Costo por tarea resuelta</span>
      <strong class="hom-kpi__valor">@if (num(r.costoPorTareaUsd) !== null) { $ {{ r.costoPorTareaUsd | number: "1.2-2" }} } @else { — }</strong>
      @if (!r.esBaseline && num(r.costoRelativo) !== null) {
        <span class="hom-kpi__nota">{{ veces(r.costoRelativo) }} el del baseline</span>
      }
    </article>
    <article class="hom-kpi">
      <span class="hom-kpi__etiqueta">Latencia p95</span>
      <strong class="hom-kpi__valor">@if (num(r.latenciaP95S) !== null) { {{ r.latenciaP95S | number: "1.0-1" }} s } @else { — }</strong>
      @if (!r.esBaseline && num(r.p95Relativo) !== null) {
        <span class="hom-kpi__nota">{{ veces(r.p95Relativo) }} la del baseline</span>
      }
    </article>
    <article class="hom-kpi">
      <span class="hom-kpi__etiqueta">Consistencia</span>
      <strong class="hom-kpi__valor">@if (num(r.consistenciaScore) !== null) { {{ r.consistenciaScore | number: "1.1-1" }} } @else { — }</strong>
      <span class="hom-kpi__nota">@if (num(r.consistenciaDesv) !== null) { σ {{ r.consistenciaDesv | number: "1.2-2" }} } @else { no medida }</span>
    </article>
    <article class="hom-kpi">
      <span class="hom-kpi__etiqueta">Tareas resueltas</span>
      <strong class="hom-kpi__valor">{{ r.tareasResueltas ?? "—" }} / {{ r.tareasTotales ?? "—" }}</strong>
    </article>
    <article class="hom-kpi">
      <span class="hom-kpi__etiqueta">Costo total · tokens</span>
      <strong class="hom-kpi__valor">@if (num(r.costoTotalUsd) !== null) { $ {{ r.costoTotalUsd | number: "1.2-2" }} } @else { — }</strong>
      <span class="hom-kpi__nota">{{ tokensK(r.tokensTotales) }} tokens</span>
    </article>
  </section>

  <!-- Condiciones eliminatorias: estado, valor y umbral -->
  <section class="hom-card">
    <h3 class="hom-h3">Condiciones eliminatorias</h3>
    <div class="hom-tabla-caja">
      <table class="table-page__table hom-interna">
        <thead>
          <tr>
            <th scope="col">Estado</th>
            <th scope="col">Condición</th>
            <th scope="col" class="hom-num">Valor</th>
            <th scope="col" class="hom-num">Umbral</th>
          </tr>
        </thead>
        <tbody>
          @for (g of r.gates || []; track g.gate) {
            <tr>
              <td>
                <span class="hom-gate" [attr.data-estado]="g.estado">
                  <i class="material-icons" aria-hidden="true">{{ gateIcono(g.estado) }}</i>
                  {{ gateTexto(g.estado) }}
                </span>
              </td>
              <td><code class="hom-mono">{{ g.gate }}</code></td>
              <td class="hom-num">@if (num(g.valor) !== null) { {{ g.valor | number: "1.0-2" }} } @else { — }</td>
              <td class="hom-num">{{ g.umbral || "—" }}</td>
            </tr>
          } @empty {
            <tr><td colspan="4">Sin condiciones registradas.</td></tr>
          }
        </tbody>
      </table>
    </div>
  </section>

  <!-- Capacidad por área: radar y tabla con los números -->
  <section class="hom-card">
    <h3 class="hom-h3">Capacidad por área</h3>
    <div class="hom-area">
      <div class="hom-area__radar">
        <app-radar-rubros [etiquetas]="etiquetas" [series]="series" [descripcion]="'Capacidad por rubro de ' + r.modelo"></app-radar-rubros>
      </div>
      <div class="hom-tabla-caja hom-area__tabla">
        <table class="table-page__table hom-interna">
          <thead>
            <tr>
              <th scope="col">Rubro</th>
              <th scope="col" class="hom-num">Peso</th>
              <th scope="col" class="hom-num">Obtenido</th>
              @if (!r.esBaseline) {
                <th scope="col" class="hom-num">Baseline</th>
                <th scope="col" class="hom-num">Δ</th>
              }
            </tr>
          </thead>
          <tbody>
            @for (x of r.rubros || []; track x.rubro) {
              <tr>
                <td>
                  <div class="table-page__cell-stack">
                    <span class="table-page__text">{{ x.nombre }}</span>
                    @if (x.queMide) {
                      <span class="table-page__subtext">{{ x.queMide }}</span>
                    }
                  </div>
                </td>
                <td class="hom-num">{{ x.peso * 100 | number: "1.1-1" }}%</td>
                <td class="hom-num"><strong>@if (num(x.valor) !== null) { {{ x.valor | number: "1.1-1" }} } @else { no aplica }</strong></td>
                @if (!r.esBaseline) {
                  <td class="hom-num">@if (num(x.valorBaseline) !== null) { {{ x.valorBaseline | number: "1.1-1" }} } @else { — }</td>
                  <td class="hom-num"><span class="hom-delta" [attr.data-signo]="signo(x.delta)">{{ conSigno(x.delta) }}</span></td>
                }
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </section>

  <!-- Capacidad por tarea: solo el nombre de cada tarea -->
  <section class="hom-card">
    <h3 class="hom-h3">Capacidad por tarea</h3>
    <div class="hom-tabla-caja">
      <table class="table-page__table hom-interna">
        <thead>
          <tr>
            <th scope="col">Tarea</th>
            <th scope="col" class="hom-num">Peso</th>
            <th scope="col" class="hom-num">Capacidad</th>
            <th scope="col">Resuelta</th>
            <th scope="col" class="hom-num">Costo</th>
            <th scope="col" class="hom-num">Latencia media</th>
          </tr>
        </thead>
        <tbody>
          @for (t of r.tareas || []; track t.tareaId) {
            <tr>
              <td>{{ t.nombre }}</td>
              <td class="hom-num">{{ t.peso | number: "1.0-2" }}</td>
              <td class="hom-num">
                <strong>@if (num(t.capacidadMedia) !== null) { {{ t.capacidadMedia | number: "1.1-1" }} } @else { — }</strong>
                @if (num(t.capacidadDesv) !== null) { <span class="table-page__subtext">± {{ t.capacidadDesv | number: "1.1-1" }}</span> }
              </td>
              <td>{{ t.resuelta ? "Sí" : "No" }}</td>
              <td class="hom-num">@if (num(t.costoUsd) !== null) { $ {{ t.costoUsd | number: "1.2-2" }} } @else { — }</td>
              <td class="hom-num">@if (num(t.latenciaMediaS) !== null) { {{ t.latenciaMediaS | number: "1.0-1" }} s } @else { — }</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </section>
</div>
